import { TextCommon } from '@esg/ui';
import React from 'react';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { currentLocaleState } from '../../state/currentLocale';
import { useAtom } from 'jotai';
const phoneUtil = PhoneNumberUtil.getInstance();

export interface LabelPhoneProps {
    phone?: string;
    phoneCountryCode?: string;
}

const getCountryCode = (
    countryCode?: string,
    defaultCountry?: string
) => {
    let finalCountryCode = countryCode;

    if (!finalCountryCode && defaultCountry) {
        try {
            const exampleNum = phoneUtil.getExampleNumber(defaultCountry.toUpperCase());
            finalCountryCode = `${exampleNum.getCountryCode()}`;
        } catch {
            finalCountryCode = '';
        }
    }

    return `+${finalCountryCode}`;
};

export const LabelPhoneNumber = (props: LabelPhoneProps) => {
    const [currentLocale] = useAtom(currentLocaleState);
    const countryCode = getCountryCode(props.phoneCountryCode, currentLocale?.country);
    return (
        <TextCommon>
            {`(${countryCode}) ${props.phone ? props.phone : ''}`}
        </TextCommon>
    );
};
